import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { AuthLink, AuthShell } from "@/pages/auth/AuthShell";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMsg(data.message);
    } catch (err) {
      setError(formatApiError(err));
    }
  };

  return (
    <AuthShell eyebrow="Account recovery" title="Reset your password"
      footer={<AuthLink to="/login" testid="forgot-back-to-login">Back to sign in</AuthLink>}>
      <form onSubmit={submit} className="space-y-4" data-testid="forgot-password-form">
        <div>
          <label className="field-label" htmlFor="forgot-email">Email</label>
          <input id="forgot-email" type="email" required className="field" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
        </div>
        {msg && (
          <p className="rounded-md border border-emerald-800/60 bg-emerald-950/40 px-3 py-2 text-sm text-emerald-300" data-testid="forgot-success">
            {msg} Email delivery is not configured yet — site staff can retrieve the link from server logs.
          </p>
        )}
        {error && <p role="alert" className="text-sm text-red-300" data-testid="forgot-error">{error}</p>}
        <button type="submit" className="btn-gold w-full" data-testid="forgot-submit-button">Send reset link</button>
      </form>
    </AuthShell>
  );
}
